module.exports = __webpack_public_path__ + "fonts/NeutraTextTF-BookItalic.f982e27a3746770fc9f4f6e265ed0c0a.otf";